<template>
    <div id="main">
        <div class="page">
            <h1 class="title">{{ $t('localizacao-vendedores') }}</h1>
            <h3>{{ $t('subtitulo-localizacao-geral') }}</h3>
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                    <li>
                        <a>{{ $t('vendas') }}</a>
                    </li>
                    <li>
                        <a>{{ $t('geoanalise') }}</a>
                    </li>
                    <li>
                        <a href="#" aria-current="page">{{ $t('localizacao-vendedores') }}</a>
                    </li>
                </ul>
            </nav>

            <!-- Mapa -->
            <div class="mapa-wrapper" :class="{ disabled: isLoading }">
                <gmap-map ref="mapRef" :center="center" :zoom="zoomLevel" :options="mapOptions">
                    <!-- Balão -->
                    <gmap-info-window
                        ref="infoWindow"
                        :position="infoWindow.position"
                        :opened="infoWindow.open"
                        :options="infoWindow.options"
                        @closeclick="infoWindow.open = false"
                    >
                        <div class="info-window">
                            <p class="info-window-nome">{{ infoWindow.item.nome }}</p>
                            <div class="info-details">
                                <span>{{ $t('sequencia') }}:</span>
                                <span class="item-detail">{{ infoWindow.item.ordem }}</span>
                                <br />
                                <span>{{ $t('latitude') }}:</span>
                                <span class="item-detail">{{
                                    infoWindow.item.lat != undefined
                                        ? formatGeo(infoWindow.item.lat)
                                        : ''
                                }}</span>
                                <br />
                                <span>{{ $t('longitude') }}:</span>
                                <span class="item-detail">{{
                                    infoWindow.item.lng != undefined
                                        ? formatGeo(infoWindow.item.lng)
                                        : ''
                                }}</span>
                                <br />
                                <span>{{ $t('velocidade') }}:</span>
                                <span class="item-detail"
                                    >{{
                                        infoWindow.item.velocidade != undefined
                                            ? formatVel(infoWindow.item.velocidade)
                                            : ''
                                    }}
                                    km/h</span
                                >
                                <br />
                                <span>{{ $t('inicio') }}:</span>
                                <span
                                    class="item-detail"
                                    v-if="infoWindow.item.datahorainc != undefined"
                                    >{{ infoWindow.item.datahorainc | moment('L LTS') }}</span
                                >
                                <br />
                                <span>{{ $t('fim') }}:</span>
                                <span
                                    class="item-detail"
                                    v-if="infoWindow.item.datahora != undefined"
                                    >{{ infoWindow.item.datahora | moment('L LTS') }}</span
                                >
                                <br />
                                <span>{{ $t('bateria-texto') }}:</span>
                                <span class="item-detail">{{ infoWindow.item.battery }} %</span>
                                <br />
                                <span>{{ $t('precisao') }}:</span>
                                <span class="item-detail"
                                    >{{ infoWindow.item.precisao }} {{ $t('metros') }}</span
                                >
                                <br />
                                <span>{{ $t('satelites') }}:</span>
                                <span class="item-detail">{{ infoWindow.item.satelites }}</span>
                                <br />
                                <span>{{ $t('tentativas') }}:</span>
                                <span class="item-detail">{{ infoWindow.item.tentativas }}</span>
                                <br />
                                <span>{{ $t('imei') }}:</span>
                                <span class="item-detail">{{ infoWindow.item.imei }}</span>
                            </div>
                        </div>
                    </gmap-info-window>

                    <!--
            @69682 - Informações refente ao pedido
          -->
                    <!-- Balao Pedido -->
                    <gmap-info-window
                        ref="infoWindowPedido"
                        :position="infoWindowPedido.position"
                        :opened="infoWindowPedido.open"
                        :options="infoWindowPedido.options"
                        @closeclick="infoWindowPedido.open = false"
                    >
                        <div class="info-window">
                            <p class="info-window-nome">{{ $t('pedido') }}</p>
                            <div class="info-details">
                                <strong>{{ $t('codigo-pedido-erp') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowPedido.item.idpedidoerp
                                }}</span>
                                <br />
                                <strong>{{ $t('usuario') }}:</strong>
                                <span class="item-detail">{{ infoWindowPedido.item.usuario }}</span>
                                <br />
                                <strong>{{ $t('codigo-cliente') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowPedido.item.codigocliente
                                }}</span>
                                <br />
                                <strong>{{ $t('cliente') }}:</strong>
                                <span class="item-detail">{{ infoWindowPedido.item.cliente }}</span>
                                <br />
                                <strong>{{ $t('ven-cliente-geral-fpgto') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowPedido.item.formapagamento
                                }}</span>
                                <br />
                                <strong>{{ $t('ven-cliente-geral-ppgto') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowPedido.item.prazopagamento
                                }}</span>
                                <div v-if="infoWindowPedido.item.datahora != undefined">
                                    <strong>{{ $t('data-inclusao') }}:</strong>
                                    <span class="item-detail">{{
                                        infoWindowPedido.item.datahora | moment('L LTS')
                                    }}</span>
                                </div>
                                <div v-if="infoWindowPedido.item.datahorainc != undefined">
                                    <strong>{{ $t('data-transmissao') }}:</strong>
                                    <span class="item-detail">{{
                                        infoWindowPedido.item.datahorainc | moment('L LTS')
                                    }}</span>
                                </div>
                                <div v-if="infoWindowPedido.item.datahoraalt != undefined">
                                    <strong>{{ $t('data-envio-erp') }}:</strong>
                                    <span class="item-detail">{{
                                        infoWindowPedido.item.datahoraalt | moment('L LTS')
                                    }}</span>
                                </div>
                                <div v-if="infoWindowPedido.item.datacheckin != undefined">
                                    <strong>{{ $t('data-check-in') }}:</strong>
                                    <span class="item-detail">{{
                                        infoWindowPedido.item.datacheckin | moment('L LTS')
                                    }}</span>
                                </div>
                                <div v-if="infoWindowPedido.item.datacheckout != undefined">
                                    <strong>{{ $t('data-check-out') }}:</strong>
                                    <span class="item-detail">{{
                                        infoWindowPedido.item.datacheckout | moment('L LTS')
                                    }}</span>
                                </div>
                                <div v-if="infoWindowPedido.item.verificouqrcode != undefined">
                                    <strong>{{ $t('verificou-qr-code-geoanalise') }}:</strong>
                                    <span class="item-detail">{{
                                        infoWindowPedido.item.verificouqrcode == 'S' ? 'Sim' : 'Não'
                                    }}</span>
                                </div>
                                <strong>{{ $t('quantidade-item') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowPedido.item.quantidadeitens
                                }}</span>
                                <br />
                                <strong>{{ $t('latitude') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowPedido.item.lat != undefined
                                        ? formatGeo(infoWindowPedido.item.lat)
                                        : ''
                                }}</span>
                                <br />
                                <strong>{{ $t('longitude') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowPedido.item.lng != undefined
                                        ? formatGeo(infoWindowPedido.item.lng)
                                        : ''
                                }}</span>
                            </div>
                            <button
                                @click="showPedidoDetalheModal(infoWindowPedido.item.idpedido)"
                                class="button btn-reset botao-informacao"
                            >
                                {{ $t('mais-informacao') }}
                            </button>
                        </div>
                    </gmap-info-window>

                    <!--
            @69682 - Informações referente ao não venda!
          -->
                    <!-- Balão Não Venda -->
                    <gmap-info-window
                        ref="infoWindowNaoVenda"
                        :position="infoWindowNaoVenda.position"
                        :opened="infoWindowNaoVenda.open"
                        :options="infoWindowNaoVenda.options"
                        @closeclick="infoWindowNaoVenda.open = false"
                    >
                        <div class="info-window">
                            <p class="info-window-nome">{{ $t('nao-venda') }}</p>
                            <div class="info-details">
                                <strong>{{ $t('vendedor') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowNaoVenda.item.usuario
                                }}</span>
                                <br />
                                <strong>{{ $t('data') }}:</strong>
                                <span
                                    class="item-detail"
                                    v-if="infoWindowNaoVenda.item.data != undefined"
                                    >{{ infoWindowNaoVenda.item.data | moment('L LTS') }}</span
                                >
                                <br />
                                <strong>{{ $t('observacao') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowNaoVenda.item.observacao
                                }}</span>
                                <br />
                                <strong>{{ $t('cliente') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowNaoVenda.item.cliente
                                }}</span>
                                <br />
                                <strong>{{ $t('contato') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowNaoVenda.item.contato
                                }}</span>
                                <br />
                                <div v-if="infoWindowNaoVenda.item.checkindatahora != undefined">
                                    <strong>{{ $t('data-check-in') }}:</strong>
                                    <span class="item-detail">{{
                                        infoWindowNaoVenda.item.checkindatahora | moment('L LTS')
                                    }}</span>
                                </div>
                                <div v-if="infoWindowNaoVenda.item.checkoutdatahora != undefined">
                                    <strong>{{ $t('data-check-out') }}:</strong>
                                    <span class="item-detail">{{
                                        infoWindowNaoVenda.item.checkoutdatahora | moment('L LTS')
                                    }}</span>
                                </div>
                                <strong>{{ $t('motivo') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowNaoVenda.item.motivo
                                }}</span>
                                <button
                                    @click="
                                        showJustificativaDetalheModal(
                                            infoWindowNaoVenda.item.idnaovenda
                                        )
                                    "
                                    class="button btn-reset botao-informacao"
                                >
                                    {{ $t('mais-informacao') }}
                                </button>
                            </div>
                        </div>
                    </gmap-info-window>

                    <!--
            @69682 - Informações referente ao checkin!
          -->
                    <!-- Balão Checkin -->
                    <gmap-info-window
                        ref="infoWindowCheckin"
                        :position="infoWindowCheckin.position"
                        :opened="infoWindowCheckin.open"
                        :options="infoWindowCheckin.options"
                        @closeclick="infoWindowCheckin.open = false"
                    >
                        <div class="info-window">
                            <p class="info-window-nome">{{ $t('check-in') }}</p>
                            <div class="info-details">
                                <strong>{{ $t('data') }}:</strong>
                                <span
                                    class="item-detail"
                                    v-if="infoWindowCheckin.item.checkindatahora != undefined"
                                    >{{
                                        infoWindowCheckin.item.checkindatahora | moment('L LTS')
                                    }}</span
                                >
                                <br />
                                <strong>{{ $t('cliente') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckin.item.cliente
                                }}</span>
                                <br />
                                <strong>{{ $t('precisao') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckin.item.precisaocheckin
                                }}</span>
                                <br />
                                <strong>{{ $t('velocidade') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckin.item.velocidadecheckin
                                }}</span>
                                <br />
                                <strong>{{ $t('verificou-qr-code-geoanalise') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckin.item.verificou == 'S' ? 'Sim' : 'Não'
                                }}</span>
                                <br />
                                <strong>{{ $t('latitude') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckin.item.lat != undefined
                                        ? formatGeo(infoWindowCheckin.item.lat)
                                        : ''
                                }}</span>
                                <br />
                                <strong>{{ $t('longitude') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckin.item.lng != undefined
                                        ? formatGeo(infoWindowCheckin.item.lng)
                                        : ''
                                }}</span>
                                <br />
                                <strong v-if="infoWindowCheckin.item.observacao !== undefined"
                                    >{{ $t('observacao') }}:</strong
                                >
                                <span class="item-detail">{{
                                    infoWindowCheckin.item.observacao
                                }}</span>
                            </div>
                        </div>
                    </gmap-info-window>

                    <!--
            @69682 - Informações referente ao checkout!
          -->
                    <!-- Balão Checkout -->
                    <gmap-info-window
                        ref="infoWindowCheckin"
                        :position="infoWindowCheckout.position"
                        :opened="infoWindowCheckout.open"
                        :options="infoWindowCheckout.options"
                        @closeclick="infoWindowCheckout.open = false"
                    >
                        <div class="info-window">
                            <p class="info-window-nome">{{ $t('check-out') }}</p>
                            <div class="info-details">
                                <strong>{{ $t('data') }}:</strong>
                                <span
                                    class="item-detail"
                                    v-if="infoWindowCheckout.item.checkoutdatahora != undefined"
                                    >{{
                                        infoWindowCheckout.item.checkoutdatahora | moment('L LTS')
                                    }}</span
                                >
                                <br />
                                <strong>{{ $t('cliente') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckout.item.cliente
                                }}</span>
                                <br />
                                <strong>{{ $t('precisao') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckout.item.precisaocheckout
                                }}</span>
                                <br />
                                <strong>{{ $t('velocidade') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckout.item.velocidadecheckout
                                }}</span>
                                <br />
                                <strong>{{ $t('verificou-qr-code-geoanalise') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckout.item.verificou == 'S' ? 'Sim' : 'Não'
                                }}</span>
                                <br />
                                <strong>{{ $t('latitude') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckout.item.lat != undefined
                                        ? formatGeo(infoWindowCheckout.item.lat)
                                        : ''
                                }}</span>
                                <br />
                                <strong>{{ $t('longitude') }}:</strong>
                                <span class="item-detail">{{
                                    infoWindowCheckout.item.lng != undefined
                                        ? formatGeo(infoWindowCheckout.item.lng)
                                        : ''
                                }}</span>
                                <br />
                                <strong v-if="infoWindowCheckout.item.observacao !== undefined"
                                    >{{ $t('observacao') }}:</strong
                                >
                                <span class="item-detail">{{
                                    infoWindowCheckout.item.observacao
                                }}</span>
                            </div>
                        </div>
                    </gmap-info-window>

                    <!-- Pins -->
                    <!-- <gmap-marker
            v-for="(m, index) in markers"
            :position="m.position"
            :icon="m.icon"
            :label="m.label"
            :key="index"
            @click="toggleInfoWindow(m)"
          /> -->

                    <!-- Linhas -->
                    <!-- <gmap-polyline
            v-for="(p, i) in paths"
            :key="`${i}-${p.idusuario}`"
            :path="p.data"
            :options="p.config"
            :editable="false"
          /> -->

                    <!-- Círculos -->
                    <gmap-circle
                        v-for="(c, index) in circles"
                        :key="`${index}-c${c.idusuario}`"
                        :center="c.center"
                        :options="c.config"
                        :radius="2"
                    />

                    <!-- Raio de Precisão -->
                    <gmap-circle
                        v-if="this.infoWindow.open"
                        :center="circle.center"
                        :options="circle.config"
                        :radius="circle.radius"
                    />
                </gmap-map>
            </div>

            <!--
        @69682 - Modal de pedido e não venda!
      -->
            <b-modal :active.sync="isShowingJustificativaDetalhe">
                <JustificativaNaoVendaDetalhada :idnaovenda="idNaoVendaDetalhe">
                </JustificativaNaoVendaDetalhada>
            </b-modal>

            <b-modal :active.sync="isShowingPedido">
                <div class="bg">
                    <PedidoModal :id="idPedidoDetalhe"></PedidoModal>
                </div>
            </b-modal>

            <!-- Botão de retrair -->
            <div
                ref="retractBtn"
                class="retract-button"
                :class="{ 'hide-control-right-btn': !showStatus }"
                v-show="!isLoading"
            >
                <div class="btn-wrapper" @click="showStatus = !showStatus">
                    <b-icon :icon="showStatus ? 'chevron-right' : 'chevron-left'" />
                </div>
            </div>

            <!-- Lista de Status - Dentro do Mapa -->
            <div
                ref="listaStatus"
                class="control-right"
                :class="{ 'hide-control-right': !showStatus }"
                v-show="!isLoading && !$root.gmapsFailure"
            >
                <!-- Alert container movido pra dentro da lista que fica dentro do maps; Permite que os avisos apareçam em full screen -->
                <alert-container :messages="msgs" />
                <div class="control-container padded is-flex">
                    <div class="columns is-multiline">
                        <div class="column is-full pb-0 is-flex is-flex-vbottom">
                            <div class="is-100">
                                <verified-date-picker
                                    v-model="datainicial"
                                    title="data"
                                    @input="changeStartDate"
                                    :inForm="true"
                                />
                            </div>
                        </div>

                        <div class="column is-full py-0 is-flex is-flex-centered">
                            <div class="is-100">
                                <vss-select
                                    class="is-default-font-size"
                                    ref="vendedorInput"
                                    title="vendedor"
                                    v-model="vendedores.selected"
                                    :options="vendedores.options"
                                    :loading="vendedores.loading"
                                    :multiple="false"
                                    :disabled="isSearching"
                                    @search="loadVendedores"
                                >
                                    <template slot="no-options">{{
                                        $t('sem-resultados-filtro')
                                    }}</template>
                                </vss-select>
                            </div>
                        </div>

                        <!--
                        @69682 - Campo para limitar quantidade de registros
                        -->
                        <div class="column is-full py-0 is-flex is-flex-centered">
                            <div class="is-100 qtde-pedidos">
                                <v-input
                                    title="qtd-pedidos-naovenda"
                                    v-model="qtdRegistros"
                                    :useMask="true"
                                    placeholder="quantidade"
                                    :maxlength="400"
                                    :vMask="['###']"
                                />
                            </div>
                        </div>

                        <div class="column is-full py-0 is-flex is-flex-centered">
                            <button
                                class="button btn-search"
                                @click="loadData"
                                :disabled="isSearching"
                            >
                                {{ $t('pesquisar') }}
                            </button>
                        </div>

                        <div class="column is-full py-0 is-flex is-flex-centered">
                            <button
                                class="button btn-reset"
                                @click="resetPositions"
                                :disabled="
                                    isSearching ||
                                    (markers.length == 0 &&
                                        listMarkersPedido.length == 0 &&
                                        listMarkersNaoVenda.length == 0 &&
                                        listMarkersCheckin.length == 0 &&
                                        listMarkersCheckout.length == 0)
                                "
                            >
                                {{ $t('redefinir-marcadores') }}
                            </button>
                        </div>

                        <div class="column is-full py-0 is-flex">
                            <div class="centralizar">
                                <label class="check-box">
                                    <input
                                        type="checkbox"
                                        v-model="centerOnSearch"
                                        :disabled="isSearching"
                                    />
                                    <span class="checkmark" />
                                </label>
                                <!--
                                @69682 - Campos adicionais para exibições no mapa
                                -->
                                <div class="checkbox-text">
                                    {{ $t('recentralizar-mapa-pesquisar') }}
                                </div>
                            </div>
                        </div>
                        <div class="column is-full py-0 is-flex">
                            <div class="is-100">
                                <hr class="separador" />
                            </div>
                        </div>
                        <div class="column is-full py-0 is-flex">
                            <div class="centralizar">
                                <label class="check-box">
                                    <input
                                        type="checkbox"
                                        :checked="visibilityMarkerPedido"
                                        @change="setVisibilityMarkers(listMarkersPedido, 'pedido')"
                                        :disabled="isSearching"
                                    />
                                    <span class="checkmark" />
                                </label>
                                <div class="checkbox-text">
                                    {{ $t('mostrar-pedido') }} ({{ this.listMarkersPedido.length }})
                                </div>
                            </div>
                        </div>
                        <div class="column is-full py-0 is-flex">
                            <div class="is-100">
                                <hr class="separador" />
                            </div>
                        </div>
                        <div class="column is-full py-0 is-flex">
                            <div class="centralizar">
                                <label class="check-box">
                                    <input
                                        type="checkbox"
                                        :checked="visibilityMarkerNaoVenda"
                                        @change="
                                            setVisibilityMarkers(listMarkersNaoVenda, 'naovenda')
                                        "
                                        :disabled="isSearching"
                                    />
                                    <span class="checkmark" />
                                </label>
                                <div class="checkbox-text">
                                    {{ $t('mostrar-naovenda') }} ({{
                                        this.listMarkersNaoVenda.length
                                    }})
                                </div>
                            </div>
                        </div>
                        <div class="column is-full py-0 is-flex">
                            <div class="is-100">
                                <hr class="separador" />
                            </div>
                        </div>
                        <div class="column is-full py-0 is-flex">
                            <div class="centralizar">
                                <label class="check-box">
                                    <input
                                        type="checkbox"
                                        :checked="visibilityMarkerCheckin"
                                        @change="
                                            setVisibilityMarkers(listMarkersCheckin, 'checkin')
                                        "
                                        :disabled="isSearching"
                                    />
                                    <span class="checkmark" />
                                </label>
                                <div class="checkbox-text">
                                    {{ $t('mostrar-checkin') }} ({{
                                        this.listMarkersCheckin.length
                                    }})
                                </div>
                            </div>
                        </div>
                        <div class="column is-full py-0 is-flex">
                            <div class="is-100">
                                <hr class="separador" />
                            </div>
                        </div>
                        <div class="column is-full py-0 is-flex">
                            <div class="centralizar">
                                <label class="check-box">
                                    <input
                                        type="checkbox"
                                        :checked="visibilityMarkerCheckout"
                                        @change="
                                            setVisibilityMarkers(listMarkersCheckout, 'checkout')
                                        "
                                        :disabled="isSearching"
                                    />
                                    <span class="checkmark" />
                                </label>
                                <div class="checkbox-text">
                                    {{ $t('mostrar-checkout') }} ({{
                                        this.listMarkersCheckout.length
                                    }})
                                </div>
                            </div>
                        </div>
                        <div class="column is-full py-0 is-flex">
                            <div class="is-100">
                                <hr class="separador" />
                            </div>
                        </div>
                        <div class="column is-full py-0 is-flex">
                            <div class="centralizar">
                                <label class="check-box">
                                    <input
                                        type="checkbox"
                                        :checked="visibilityPercurso"
                                        @change="removePaths()"
                                        :disabled="isSearching"
                                    />
                                    <span class="checkmark" />
                                </label>
                                <div class="checkbox-text">
                                    {{ $t('mostrar-percurso') }} ({{ this.markers.length }})
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GeoanaliseService from '@/services/GeoanaliseService';
import paleta from '@/functions/color/paleta.js';
import Message from '@/models/Message';
import JustificativaNaoVendaDetalhada from '@/components/vendas/relatorios/JustificativaNaoVendaDetalhada';
import PedidoModal from '@/components/vendas/pedido/PedidoModal';
import ColaboradorService from '@/services/ColaboradorService';
import { TheMask } from 'vue-the-mask';

export default {
    components: {
        /**
         * @69682 - Componentes para o modal
         */
        JustificativaNaoVendaDetalhada,
        PedidoModal,
        TheMask,
    },
    data() {
        return {
            cluster: null,
            center: { lat: -15, lng: -50 },
            zoomLevel: 4,
            isLoading: true,
            isSearching: false,
            markers: [],
            /**
             * @69682 - Lista de pedido e nao venda e visibilidade dos marcadores e percurso
             */
            listMarkersPedido: [],
            listMarkersNaoVenda: [],
            listMarkersCheckin: [],
            listMarkersCheckout: [],
            visibilityMarkerPedido: false,
            visibilityMarkerNaoVenda: false,
            visibilityPercurso: true,
            visibilityMarkerCheckin: false,
            visibilityMarkerCheckout: false,
            idNaoVendaDetalhe: 0,
            idPedidoDetalhe: 0,
            isShowingJustificativaDetalhe: false,
            isShowingPedido: false,
            users: {},
            paths: [],
            map: null,
            centerOnSearch: true,
            qtdRegistros: null,
            infoWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
                detailsOpen: false,
                item: {},
            },
            colors: [],
            mapOptions: {
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                zoomControl: false,
                fullscreenControl: true,
                clickableIcons: false,
                fullscreenControlOptions: {
                    position: 7, // google.maps.ControlPosition.RIGHT_TOP
                },
            },
            polylineIcon: [
                {
                    icon: { path: 1 /*google.maps.SymbolPath.FORWARD_OPEN_ARROW*/ },
                    offset: '40%',
                    repeat: '50px',
                },
            ],
            polylineOptions: {},
            infoWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
                item: {},
                options: {
                    pixelOffset: { width: 0, height: -35 },
                },
            },
            /**
             * @69682 - Informações dos pedidos e não venda
             */
            infoWindowPedido: {
                position: { lat: 0, lng: 0 },
                open: false,
                item: {},
                options: {
                    pixelOffset: { width: 0, height: -35 },
                },
            },
            infoWindowNaoVenda: {
                position: { lat: 0, lng: 0 },
                open: false,
                item: {},
                options: {
                    pixelOffset: { width: 0, height: -35 },
                },
            },
            infoWindowCheckin: {
                position: { lat: 0, lng: 0 },
                open: false,
                item: {},
                options: {
                    pixelOffset: { width: 0, height: -35 },
                },
            },
            infoWindowCheckout: {
                position: { lat: 0, lng: 0 },
                open: false,
                item: {},
                options: {
                    pixelOffset: { width: 0, height: -35 },
                },
            },
            // svgpath: "M10.0812 0.00417221V0C10.0537 0 10.0269 0.00166887 10 0.00166887C9.97313 0.00166887 9.94626 0 9.91877 0V0.00417221C4.42628 0.0930404 0 4.64555 0 10.2528C0 17.8089 8.72292 24.9809 10 26C11.2773 24.9811 20 17.8087 20 10.2528C20 4.64555 15.5739 0.0930404 10.0812 0.00417221ZM10.0812 14.663C7.20729 14.663 4.87795 12.2945 4.87795 9.37205C4.87795 6.44879 7.20729 4.0798 10.0812 4.0798C12.9552 4.0798 15.2847 6.44879 15.2847 9.37205C15.2847 12.2945 12.9552 14.663 10.0812 14.663Z",
            svgpath: 'M 0,0 L -13.13,-23.74 A 15 15 1 1 1 13.13,-23.74 L 0,0 z',
            msgs: [],
            showStatus: true,
            vendedores: {
                loading: false,
                selected: [],
                options: [],
            },
            datainicial: (() => {
                let trintaDiasAtras = new Date();
                trintaDiasAtras.setDate(trintaDiasAtras.getDate() - 31);
                return trintaDiasAtras;
            })(),
            circle: {
                radius: 0,
                center: {},
                config: { strokeColor: '#9C27B0', fillColor: '#9C27B0' },
            },
            circles: [],
            circleStart: { strokeColor: '#4CAF50', fillColor: '#4CAF50' },
            circleEnd: { strokeColor: '#F44336', fillColor: '#F44336' },
            permissao: {},
            corVendedor: '',
            colaboradorService: null,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'vendas',
            'relatorio-geoanalise',
            'mapa-localizacao-vendedor'
        );

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'localizacao-vendedores' },
            });

        this.colors = paleta.colorList;
        this.service = new GeoanaliseService(this.$http, this.$router);
        this.colaboradorService = new ColaboradorService(this.$http, this.$router);
        this.loadVendedores('');
    },
    mounted() {
        this.$refs.mapRef.$mapPromise.then((map) => {
            this.isLoading = false;
            map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.retractBtn);
            map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.listaStatus);
        });

        let inputSearch = this.$refs.vendedorInput.$refs.search;
        inputSearch.addEventListener('focusin', () => this.loadVendedores(''));
    },
    methods: {
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        loadData() {
            if (this.validateDatas()) {
                this.isSearching = true;
                const self = this;
                this.$refs.mapRef.$mapPromise.then((map) => {
                    let filtros = {
                        ini: this.datainicial
                            ? this.$moment(this.datainicial).format('YYYY-MM-DD')
                            : null,
                        idvendedor: this.vendedores.selected.id,
                        quantidaderegistros: this.qtdRegistros == null ? 0 : this.qtdRegistros,
                    };

                    this.markers.forEach((m) => {
                        m.setMap(null);
                    });

                    this.listMarkersPedido.forEach((m) => {
                        m.setMap(null);
                    });

                    this.listMarkersNaoVenda.forEach((m) => {
                        m.setMap(null);
                    });

                    this.listMarkersCheckin.forEach((m) => {
                        m.setMap(null);
                    });

                    this.listMarkersCheckout.forEach((m) => {
                        m.setMap(null);
                    });

                    this.paths.forEach((p) => {
                        p.setMap(null);
                    });

                    this.service
                        .findAllSellers(filtros)
                        .then((r) => {
                            this.users = {};
                            this.markers = [];
                            this.listMarkersPedido = [];
                            this.listMarkersNaoVenda = [];
                            this.listMarkersCheckin = [];
                            this.listMarkersCheckout = [];
                            this.circles = [];
                            this.paths = [];
                            this.infoWindow.open = false;
                            this.infoWindowPedido.open = false;
                            this.infoWindowNaoVenda.open = false;
                            this.infoWindowCheckin.open = false;
                            this.infoWindowCheckout.open = false;

                            if (r) {
                                r.listaLocalizacao.sort((m1, m2) => m1.idusuario - m2.idusuario);

                                let count = 1,
                                    current =
                                        r.listaLocalizacao.length > 0
                                            ? r.listaLocalizacao[0].idusuario
                                            : 0;

                                r.listaLocalizacao.forEach((m) => {
                                    this.corVendedor = m.pincolor;
                                    if (count > 1 && m.idusuario != current) {
                                        count = 1;
                                        current = m.idusuario;

                                        if (r.listaLocalizacao.length > 1) {
                                            this.markers[
                                                this.markers.length - 1
                                            ].icon.strokeWeight = 2;
                                            this.markers[this.markers.length - 1].icon.strokeColor =
                                                '#F44336';
                                        }
                                    }

                                    if (this.users[m.idusuario] == undefined) {
                                        this.users[m.idusuario] = {
                                            idusuario: m.idusuario,
                                            nome: m.nome,
                                            pincolor: m.pincolor,
                                        };
                                    }

                                    let marker = new google.maps.Marker({
                                        map: map,
                                        idusuario: m.idusuario,
                                        position: {
                                            lat: m.latitude,
                                            lng: m.longitude,
                                        },
                                        optimized: true,
                                        icon: {
                                            path: this.svgpath,
                                            fillColor: `#${m.pincolor}`,
                                            scale: 1,
                                            fillOpacity: 1,
                                            strokeWeight: 2,
                                            strokeColor:
                                                count == 1
                                                    ? '#4CAF50'
                                                    : `#${this.lightenDarkenColor(m.pincolor, -20)}`,
                                            anchor: { x: 0, y: 0 },
                                            labelOrigin: { x: 0, y: -30 },
                                        },
                                        label: {
                                            text: `${count}`,
                                            color: this.isColorLight(`#${m.pincolor}`)
                                                ? `#${this.lightenDarkenColor(m.pincolor, -40)}`
                                                : '#FFF',
                                            fontWeight: '600',
                                            fontFamily: 'Montserrat,sans-serif',
                                        },
                                        data: {
                                            nome: m.nome,
                                            lat: m.latitude,
                                            lng: m.longitude,
                                            velocidade: m.velocidade * 1.852, // Velocidade medida em nós
                                            datahora: new Date(m.datahora),
                                            battery: m.battery,
                                            ordem: count,
                                            precisao: m.precisao,
                                            satelites: m.satelites,
                                            tentativas: m.tentativas,
                                            imei: m.imei,
                                            datahorainc: new Date(m.datahorainc),
                                            pincolor: `#${m.pincolor}`,
                                        },
                                        zIndex: 20 + this.markers.length,
                                        draggable: true,
                                    });

                                    marker.addListener('click', function () {
                                        self.toggleInfoWindow(marker);
                                    });

                                    marker.setVisible(this.visibilityPercurso);

                                    this.markers.push(marker);

                                    count++;
                                });

                                /**
                                 * @69682 - Adicionando marcadores pedido
                                 */
                                r.listaPedido.forEach((p) => {
                                    let markerPedido = new google.maps.Marker({
                                        map: map,
                                        idpedido: p.idpedido,
                                        position: {
                                            lat: p.latitude,
                                            lng: p.longitude,
                                        },
                                        optimized: true,
                                        icon: {
                                            path: this.svgpath,
                                            fillColor: `#${this.corVendedor}`,
                                            scale: 1,
                                            fillOpacity: 1,
                                            strokeWeight: 0,
                                            anchor: { x: 0, y: 0 },
                                            labelOrigin: { x: 0, y: -30 },
                                        },
                                        label: {
                                            text: 'P',
                                            color: this.isColorLight(`#${this.corVendedor}`)
                                                ? `#${this.lightenDarkenColor(this.corVendedor, -40)}`
                                                : '#FFF',
                                            fontWeight: '600',
                                            fontFamily: 'Montserrat,sans-serif',
                                        },
                                        data: {
                                            idpedido: p.idpedido,
                                            idpedidoerp: p.idpedidoerp,
                                            usuario: p.vendedor,
                                            codigocliente: p.idcliente,
                                            idpedidousuario: p.idpedidousuario,
                                            cliente: p.cli_nome,
                                            clientesocial: p.cli_rsocial,
                                            tipopedido: p.tipopedido,
                                            formapagamento: p.formapagamento,
                                            prazopagamento: p.prazopagamento,
                                            registroenviado: p.registro_enviado,
                                            datahora: p.datahora,
                                            datahorainc: p.datahorainc,
                                            datahoraalt: p.datahoraalt,
                                            datacheckin: p.checks.checkindatahora,
                                            datacheckout: p.checks.checkoutdatahora,
                                            verificouqrcode: p.checks.verificouqrcode,
                                            quantidadeitens: p.quantidadeitens,
                                            lat: p.latitude,
                                            lng: p.longitude,
                                        },
                                        draggable: true,
                                    });

                                    markerPedido.addListener('click', function () {
                                        self.toggleInfoWindowPedido(markerPedido);
                                    });

                                    markerPedido.setVisible(this.visibilityMarkerPedido);

                                    this.listMarkersPedido.push(markerPedido);
                                });

                                /**
                                 * @69682 - Adicionando marcadores nao venda
                                 */
                                r.listaNaoVenda.forEach((nv) => {
                                    let markerNaoVenda = new google.maps.Marker({
                                        map: map,
                                        idpedido: nv.idnaovenda,
                                        position: {
                                            lat: nv.latitude,
                                            lng: nv.longitude,
                                        },
                                        optimized: true,
                                        icon: {
                                            path: this.svgpath,
                                            fillColor: `#${this.corVendedor}`,
                                            scale: 1,
                                            fillOpacity: 1,
                                            strokeWeight: 0,
                                            anchor: { x: 0, y: 0 },
                                            labelOrigin: { x: 0, y: -30 },
                                        },
                                        label: {
                                            text: 'NV',
                                            color: this.isColorLight(`#${this.corVendedor}`)
                                                ? `#${this.lightenDarkenColor(this.corVendedor, -40)}`
                                                : '#FFF',
                                            fontWeight: '600',
                                            fontFamily: 'Montserrat,sans-serif',
                                        },
                                        data: {
                                            idnaovenda: nv.idnaovenda,
                                            usuario: nv.usuario.nome,
                                            data: nv.datahora,
                                            observacao: nv.descricao,
                                            cliente: nv.cliente.nome,
                                            contato: nv.contato,
                                            motivo: nv.motivonaovenda.descricao,
                                            lat: nv.latitude,
                                            lng: nv.longitude,
                                            checkindatahora: nv.checks.checkindatahora,
                                            checkoutdatahora: nv.checks.checkoutdatahora,
                                        },
                                        draggable: true,
                                    });

                                    markerNaoVenda.addListener('click', function () {
                                        self.toggleInfoWindowNaoVenda(markerNaoVenda);
                                    });

                                    markerNaoVenda.setVisible(this.visibilityMarkerNaoVenda);

                                    this.listMarkersNaoVenda.push(markerNaoVenda);
                                });

                                /**
                                 * @69682 - Adicioanando Marcadores Checkin/Checkout
                                 */
                                r.listaChecks.forEach((ck) => {
                                    let markerCheckin = new google.maps.Marker({
                                        map: map,
                                        idpedido: ck.idcheck,
                                        idusuario: ck.idusuario,
                                        position: {
                                            lat: ck.latitudecheckin,
                                            lng: ck.longitudecheckin,
                                        },
                                        optimized: true,
                                        icon: {
                                            path: this.svgpath,
                                            fillColor: `#${this.corVendedor}`,
                                            scale: 1,
                                            fillOpacity: 1,
                                            strokeWeight: 0,
                                            anchor: { x: 0, y: 0 },
                                            labelOrigin: { x: 0, y: -30 },
                                        },
                                        label: {
                                            text: 'CI',
                                            color: this.isColorLight(`#${this.corVendedor}`)
                                                ? `#${this.lightenDarkenColor(this.corVendedor, -40)}`
                                                : '#FFF',
                                            fontWeight: '600',
                                            fontFamily: 'Montserrat,sans-serif',
                                        },
                                        data: {
                                            idcheckin: ck.idcheck,
                                            cliente: ck.cliente.nome,
                                            precisaocheckin: ck.precisaocheckin,
                                            velocidadecheckin: ck.velocidadecheckin,
                                            verificouqrcode: ck.verificouqrcode,
                                            lat: ck.latitudecheckin,
                                            lng: ck.longitudecheckin,
                                            checkindatahora: ck.checkindatahora,
                                            observacao: ck.observacao,
                                        },
                                        draggable: true,
                                    });

                                    let markerCheckout = new google.maps.Marker({
                                        map: map,
                                        idpedido: ck.idcheck,
                                        position: {
                                            lat: ck.latitudecheckout,
                                            lng: ck.longitudecheckout,
                                        },
                                        optimized: true,
                                        icon: {
                                            path: this.svgpath,
                                            fillColor: `#${this.corVendedor}`,
                                            scale: 1,
                                            fillOpacity: 1,
                                            strokeWeight: 0,
                                            anchor: { x: 0, y: 0 },
                                            labelOrigin: { x: 0, y: -30 },
                                        },
                                        label: {
                                            text: 'CO',
                                            color: this.isColorLight(`#${this.corVendedor}`)
                                                ? `#${this.lightenDarkenColor(this.corVendedor, -40)}`
                                                : '#FFF',
                                            fontWeight: '600',
                                            fontFamily: 'Montserrat,sans-serif',
                                        },
                                        data: {
                                            idcheckin: ck.idcheck,
                                            cliente: ck.cliente.nome,
                                            precisaocheckout: ck.precisaocheckout,
                                            velocidadecheckout: ck.velocidadecheckout,
                                            verificouqrcode: ck.verificouqrcode,
                                            lat: ck.latitudecheckout,
                                            lng: ck.longitudecheckout,
                                            checkoutdatahora: ck.checkoutdatahora,
                                            observacao: ck.observacao,
                                        },
                                        draggable: true,
                                    });

                                    markerCheckin.addListener('click', function () {
                                        self.toggleInfoWindowCheckin(markerCheckin);
                                    });

                                    markerCheckin.setVisible(this.visibilityMarkerCheckin);

                                    this.listMarkersCheckin.push(markerCheckin);

                                    markerCheckout.addListener('click', function () {
                                        self.toggleInfoWindowCheckout(markerCheckout);
                                    });

                                    markerCheckout.setVisible(this.visibilityMarkerCheckout);

                                    this.listMarkersCheckout.push(markerCheckout);
                                });

                                if (
                                    this.markers.length == 0 &&
                                    this.listMarkersPedido.length == 0 &&
                                    this.listMarkersNaoVenda.length == 0 &&
                                    this.listMarkersCheckin.length == 0 &&
                                    this.listMarkersCheckout.length == 0
                                ) {
                                    this.showMessage('alert', 'msg-warning-loc-noresults');

                                    if (this.centerOnSearch) {
                                        map.setCenter(this.center);
                                        map.setZoom(this.zoomLevel);
                                    }
                                } else {
                                    if (r.listaLocalizacao.length > 1) {
                                        this.markers[this.markers.length - 1].icon.strokeWeight = 2;
                                        this.markers[this.markers.length - 1].icon.strokeColor =
                                            '#F44336';
                                    }

                                    if (this.visibilityPercurso) {
                                        this.paths = this.getPaths(map);
                                    }

                                    this.map = map;

                                    if (this.centerOnSearch) {
                                        let bounds = new google.maps.LatLngBounds();

                                        this.markers.forEach((m) => {
                                            bounds.extend(m.position);
                                        });

                                        this.listMarkersPedido.forEach((m) => {
                                            bounds.extend(m.position);
                                        });

                                        this.listMarkersNaoVenda.forEach((m) => {
                                            bounds.extend(m.position);
                                        });

                                        this.listMarkersCheckin.forEach((m) => {
                                            bounds.extend(m.position);
                                        });

                                        this.listMarkersCheckout.forEach((m) => {
                                            bounds.extend(m.position);
                                        });

                                        map.fitBounds(bounds);
                                    }
                                }
                            }

                            setTimeout(() => {
                                this.gmnoprintZindex();
                            }, 1000);
                        })
                        .catch((e) => {
                            console.error('Erro ao carregar dados do mapa.', e);
                            this.showMessage('error', 'msg-error-loc');
                        })
                        .finally(() => {
                            this.isSearching = false;
                        });
                });
            }
        },
        validateDatas() {
            let valid = true;

            /**
             * @69682 - Verificando se o limite e maior
             */
            if (this.qtdRegistros > 400) {
                this.showMessage('alert', 'msg-erro-quantidade-maxima');
                valid = false;
            }

            /**
             * @69682 - Verificando se existe algum vendedor selecionado
             */
            if (this.vendedores.selected != null) {
                if (this.vendedores.selected.length == 0) {
                    this.showMessage('alert', 'msg-erro-vendedor-nao-selecionado');
                    valid = false;
                }
            } else {
                this.showMessage('alert', 'msg-erro-vendedor-nao-selecionado');
                valid = false;
            }

            return valid;
        },
        formatGeo(number) {
            return number.toLocaleString(undefined, {
                minimumFractionDigits: 6,
                maximumFractionDigits: 6,
            });
        },
        formatVel(number) {
            return number.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            });
        },
        getPeriodoStringFromDate(d) {
            return `${d.getDate() < 10 ? '0' : ''}${d.getDate()}/${d.getMonth() < 9 ? '0' : ''}${
                d.getMonth() + 1
            }/${d.getFullYear()}`;
        },
        toggleInfoWindow(marker) {
            if (marker.data.idlocalizacao == this.infoWindow.item.idlocalizacao) {
                this.infoWindow.open = !this.infoWindow.open;
            } else {
                this.infoWindow.open = true;
            }

            this.infoWindow.position = marker.position;
            this.infoWindow.item = marker.data;

            this.circle.config = {
                strokeColor: marker.data.pincolor,
                fillColor: marker.data.pincolor,
            };
            this.circle.center = marker.position;
            this.circle.radius = marker.data.precisao;
        },
        /**
         * @69682 - Exibir informacoes dos pedidos, nao venda, checkin, checkout
         */
        toggleInfoWindowPedido(markerPedido) {
            if (markerPedido.data.idpedido == this.infoWindowPedido.item.idpedido) {
                this.infoWindowPedido.open = !this.infoWindowPedido.open;
            } else {
                this.infoWindowPedido.open = true;
            }

            this.infoWindowPedido.position = markerPedido.position;
            this.infoWindowPedido.item = markerPedido.data;
        },
        toggleInfoWindowNaoVenda(markerNaoVenda) {
            if (markerNaoVenda.data.idnaovenda == this.infoWindowNaoVenda.item.idnaovenda) {
                this.infoWindowNaoVenda.open = !this.infoWindowNaoVenda.open;
            } else {
                this.infoWindowNaoVenda.open = true;
            }

            this.infoWindowNaoVenda.position = markerNaoVenda.position;
            this.infoWindowNaoVenda.item = markerNaoVenda.data;
        },
        toggleInfoWindowCheckin(markerCheckin) {
            if (markerCheckin.data.idcheck == this.infoWindowCheckin.item.idcheck) {
                this.infoWindowCheckin.open = !this.infoWindowCheckin.open;
            } else {
                this.infoWindowCheckin.open = true;
            }

            this.infoWindowCheckin.position = markerCheckin.position;
            this.infoWindowCheckin.item = markerCheckin.data;
        },
        toggleInfoWindowCheckout(markerCheckout) {
            if (markerCheckout.data.idcheck == this.infoWindowCheckout.item.idcheck) {
                this.infoWindowCheckout.open = !this.infoWindowCheckout.open;
            } else {
                this.infoWindowCheckout.open = true;
            }

            this.infoWindowCheckout.position = markerCheckout.position;
            this.infoWindowCheckout.item = markerCheckout.data;
        },
        // Recebe o $emit do VerifiedDatePicker, adiciona o valor na variavel local que retorna para a prop do VerifiedDatePiker
        changeStartDate(date) {
            this.datainicial = date;
        },
        getPaths(map) {
            let p = [];

            for (var v in this.users) {
                var flightPath = new google.maps.Polyline({
                    options: {
                        strokeColor: `#${this.users[v].pincolor}`,
                        icons: this.polylineIcon,
                        zIndex: 10,
                    },
                    path: this.markers.filter((m) => m.idusuario == v).map((m) => m.position),
                    editable: false,
                });
                p.push(flightPath);
                flightPath.setMap(map);
            }

            return p;
        },
        /**
         * @69682 - Exibir modais e remover percurso do mapa
         */
        showJustificativaDetalheModal(id) {
            this.isShowingJustificativaDetalhe = !this.isShowingJustificativaDetalhe;
            this.idNaoVendaDetalhe = id;
        },
        showPedidoDetalheModal(id) {
            this.isShowingPedido = !this.isShowingPedido;
            this.idPedidoDetalhe = id;
        },
        removePaths() {
            this.visibilityPercurso = !this.visibilityPercurso;
            if (!this.visibilityPercurso) {
                for (var fp of this.paths) {
                    fp.setMap(null);
                }
                for (var marker of this.markers) {
                    marker.setVisible(false);
                }
            } else {
                this.paths = this.getPaths(this.map);
                for (var marker of this.markers) {
                    marker.setVisible(true);
                }
            }
        },
        loadVendedores(searchQuery) {
            this.vendedores.loading = true;

            /*
                @70881 - alterado para trazer a lista de vendedores vinculados ao usuario.
            */
            this.colaboradorService
                .findListAssociated(searchQuery, 5000000)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro com status ${r.status} ao realizar pesquisa por vendedor. Termo: [${q}].`
                        );
                        this.vendedores.options = [];
                    } else {
                        this.vendedores.options = r.content.map((v) => {
                            return {
                                id: v.id,
                                label: v.nome.toLocaleUpperCase(),
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa por vendedor. Termo: [${q}].`, e);
                    this.vendedores.options = [];
                })
                .finally(() => {
                    this.vendedores.loading = false;
                });
        },
        gmnoprintZindex() {
            // Removendo o z-index dos avisos de copyright do mapa para o aviso poder aparecer normal e em full screen
            document.querySelectorAll('.gmnoprint').forEach((e) => {
                if (e.style.zIndex) {
                    e.style.zIndex = 0;
                }
            });
        },
        resetPositions() {
            this.infoWindow.open = false;
            this.infoWindowPedido.open = false;
            this.infoWindowNaoVenda.open = false;
            this.infoWindowCheckin.open = false;
            this.infoWindowCheckout.open = false;

            this.markers.forEach((m) => {
                let latitude = m.data.lat;
                let longitude = m.data.lng;
                m.setPosition({ lat: latitude, lng: longitude });
            });

            this.listMarkersPedido.forEach((m) => {
                let latitude = m.data.lat;
                let longitude = m.data.lng;
                m.setPosition({ lat: latitude, lng: longitude });
            });

            this.listMarkersNaoVenda.forEach((m) => {
                let latitude = m.data.lat;
                let longitude = m.data.lng;
                m.setPosition({ lat: latitude, lng: longitude });
            });

            this.listMarkersCheckin.forEach((m) => {
                let latitude = m.data.lat;
                let longitude = m.data.lng;
                m.setPosition({ lat: latitude, lng: longitude });
            });

            this.listMarkersCheckout.forEach((m) => {
                let latitude = m.data.lat;
                let longitude = m.data.lng;
                m.setPosition({ lat: latitude, lng: longitude });
            });
        },
        /**
         * @69682 - Altera se exibe ou nao os pedidos, nao venda, checkin, checkout
         */
        setVisibilityMarkers(lista, alterar) {
            let visibility;

            if (alterar === 'pedido') {
                this.visibilityMarkerPedido = !this.visibilityMarkerPedido;
                visibility = this.visibilityMarkerPedido;
            } else if (alterar === 'naovenda') {
                this.visibilityMarkerNaoVenda = !this.visibilityMarkerNaoVenda;
                visibility = this.visibilityMarkerNaoVenda;
            } else if (alterar === 'checkin') {
                this.visibilityMarkerCheckin = !this.visibilityMarkerCheckin;
                visibility = this.visibilityMarkerCheckin;
            } else {
                this.visibilityMarkerCheckout = !this.visibilityMarkerCheckout;
                visibility = this.visibilityMarkerCheckout;
            }

            for (var i = 0; i < lista.length; i++) {
                lista[i].setVisible(visibility);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@mixin border() {
    border: 1px solid $table-border;
    border-radius: 3px;
}

#main {
    padding: 0px 20px;
    height: 100%;
}

.page {
    position: relative;
}

h1.title {
    margin-right: 0;
    margin-bottom: 0;
}

.mapa-wrapper {
    .vue-map-container {
        width: 100%;
        height: calc(100vh - 140px);
    }
}

.disabled {
    opacity: 0.2;
    pointer-events: none;
}

.item-detail {
    float: right;
}

.check-box {
    margin-bottom: 0;
    // margin-left: 5px;

    .checkmark {
        position: inherit;
        display: inline-flex;
        top: 0;
        right: 0;
        height: 16px;
        width: 16px;
        border: 2px solid $primary-color-hover;
        margin-top: 2px;
        border-radius: 3px;
    }
}

.botao-informacao {
    width: 100%;
    margin-top: 5px;
    height: 28px;
    font-size: 12px;
    -webkit-box-shadow: rgba(0, 0, 0, 0.25);
    box-shadow: rgba(0, 0, 0, 0.25);
    background: #f3f2f2;
    outline: none;
}

.separador {
    padding: 0;
    margin: 0;
}

.qtde-pedidos {
    font-size: 14px;
}
</style>
